import { render, staticRenderFns } from "./EaseInBackBorderIcon.vue?vue&type=template&id=5a898e6c&"
import script from "./EaseInBackBorderIcon.vue?vue&type=script&lang=js&"
export * from "./EaseInBackBorderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports